export let currentFolderScopeLabel = "$RHJtb";
export let recursiveFolderScopeLabel = "s1_i0d";
export let allMailboxesScopeLabel = "nUbPfd";
export let allPstFilesScopeLabel = "t_wumc";
export default {currentFolderScopeLabel,recursiveFolderScopeLabel,allMailboxesScopeLabel,allPstFilesScopeLabel};